export default __webpack_public_path__ + "static/media/gon1_assembled_potato.fa.f1bcf89e.fai";